import ReactGA from "react-ga4";

const initializeAnalytics = () => {
  ReactGA.initialize("G-D7QQXR5VQR");
};

export default initializeAnalytics;
